<template>
    <el-dialog
        class="add-or-edit-contact-dialog"
        :close-on-click-modal="false"
        :title="title"
        :visible.sync="openAddOrEditDialog"
        :top="approve ? '1%' : '4%'"
        width="650px"
        style="padding: 0 50px 50px 0;"
        :before-close="closeDialog">
        <div class="approve-info" v-if="approve">
            <el-row class="line">
                <el-col :span="2" class="approve-name-title"><span>审批人： </span></el-col>
                <el-col :span="5" class="approve-name-content"><span>{{ approveInfo.approvalUserName }}</span></el-col>
                <el-col :span="5"><span>审批进度： </span><span>{{ approveInfo.approvalStatusText }}</span></el-col>
                <el-col :span="8"><span>提交时间： </span><span>{{ approveInfo.commitTime }}</span></el-col>
                <el-col :span="2">
                    <el-button v-if="approveInfo.approvalStatus === AUDIT_STATUS.PENDING && approveInfo.commitUserCode.toLowerCase() === $store.state.user.userCode.toLowerCase()"
                        type="primary" size="mini" @click="handleRevoke">撤 回</el-button>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="2" v-if="approveInfo.approvalStatus === AUDIT_STATUS.REJECT" class="approve-reason-title"><span>驳回理由： </span></el-col>
                <el-col :span="10" v-if="approveInfo.approvalStatus === AUDIT_STATUS.REJECT" class="approve-reason-content"><span>{{ approveInfo.approvalOpinion }}</span></el-col>
                <el-col :span="13"  v-else><div style="width: 100%; height: 16px;"></div></el-col>
                <el-col :span="9"><span>审批时间： </span><span>{{ approveInfo.approvalTime }}</span></el-col>
            </el-row>
        </div>
        <div v-if="approve" style=" margin: 10px 0;width: 100%; border-bottom: 1px solid #e6e6e6"></div>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="mini" style="font-size: 14px;">
            <el-form-item label="姓名" prop="contacts">
                <el-input v-model.trim="form.contacts" :disabled="approve" class="normal_input" maxlength="50" placeholder="请输入您的姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证" prop="idCard">
                <el-input v-model.trim="form.idCard" :disabled="approve" class="normal_input" placeholder="请输入您的身份证号"></el-input>
            </el-form-item>
            <el-form-item label="联系人账号类型" prop="userType">
                <el-radio-group v-model="form.userType">
                    <el-radio :disabled="approve || !manage || !addOrEdit" :label="ONE">主账号</el-radio>
                    <el-radio :disabled="approve || !manage || !addOrEdit" :label="TWO">子账号<span class="userType-remark">(推送会计主体不会推送子账号信息)</span></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="开通联系人账号" prop="createUserFlag" v-if="addOrEdit">
                <el-radio-group v-model="form.createUserFlag" :disabled="approve">
                    <el-radio :label="ZERO">是</el-radio>
                    <el-radio :label="ONE">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否驻点人员" prop="residentPerson">
                <el-radio-group v-model="form.residentPerson" :disabled="approve">
                    <el-radio :label="ZERO">是</el-radio>
                    <el-radio :label="ONE">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否在途联系人" prop="onWayContactFlag" v-if="isLgtPptSup">
                <el-radio-group v-model="form.onWayContactFlag" :disabled="approve">
                    <el-radio :label="ONE">是</el-radio>
                    <el-radio :label="ZERO">否<span class="on-way-contact-flag-remark">(此联系人作为日常货物跟踪联系人)</span></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="手机号码" prop="contactsMobile">
                <el-input v-model.trim="form.contactsMobile" :disabled="approve" maxlength="11" class="normal_input" placeholder="请输入您的手机号码"></el-input>
            </el-form-item>
            <el-form-item label="联系电话（对公）" prop="contactsPhone">
                <el-input v-model.trim="form.contactsPhone" :disabled="approve" class="normal_input" placeholder="请输入联系电话（对公）"></el-input>
            </el-form-item>
            <el-form-item label="公司邮箱（对公）" prop="contactsEmail">
                <el-input v-model.trim="form.contactsEmail" :disabled="approve" class="normal_input" placeholder="请输入公司邮箱（对公）"></el-input>
            </el-form-item>
            <el-form-item label="职务" prop="contactsPost">
                <el-input v-model.trim="form.contactsPost" :disabled="approve" class="normal_input" placeholder="请输入您的职务"></el-input>
            </el-form-item>
            <el-row>
                <el-col :span="24" class="address">
                    <el-form-item label="办公地址" prop="countryCode" class="country">
                        <el-select v-model="form.countryCode" placeholder="国家" :disabled="approve" clearable>
                            <el-option
                                v-for="(item, index) in countryOptions"
                                :key="item.value + index"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="provinceCode" class="province">
                        <el-select v-model="form.provinceCode" placeholder="省份" :disabled="approve" clearable>
                            <el-option
                                v-for="(item, index) in provinceOptions"
                                :key="item.value + index"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="cityCode" class="city">
                        <el-select v-model="form.cityCode" placeholder="城市" :disabled="approve" clearable>
                            <el-option
                                v-for="(item, index) in cityOptions"
                                :key="item.value + index"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item prop="contactsAddress">
                <el-input v-model.trim="form.contactsAddress" :disabled="approve" class="normal_input" placeholder="请输入详细地址"></el-input>
            </el-form-item>
            <!-- 委派函 -->
            <el-row v-if="form.residentPerson === ZERO">
                <el-col :span="16">
                    <el-form-item label="委派函" prop="delegateFileName" class="upload-item">
                        <el-input v-model="form.delegateFileName" :disabled="approve" placeholder="点击上传附件" readonly></el-input>
                        <register-upload
                            :disabled="approve"
                            :uploadDisplayType="'icon'"
                            :sizeLimit="6"
                            :typeLimit="{reg: '^\.(jpg|jpeg|png)$', warningText: 'jpg、jpeg、png'}"
                            :accept="'image/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf'"
                            :flag="uploadFileData.fileName + '#' + uploadFileData.fileUrl + '#' + uploadFileData.fileId"
                            class="upload-item-icon three-btn"
                            @uploadSuccess="uploadSuccess"
                        ></register-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="2" class="preview">
                    <el-popover placement="right" width="500" trigger="click" @show="showpopover(uploadFileData.example)">
                        <div style="text-align: center" :style="{width: uploadFileData.examplePicWidth, height: uploadFileData.examplePicHeight}">
                            <img :src="fileData.imgSrcPathObj[uploadFileData.example]" style="height: 100%">
                        </div>
                        <span slot="reference" v-popover:popover1 class="example-btn">示例</span>
                    </el-popover>
                </el-col>
                <el-col :span="2" class="preview">
                    <span @click="view(uploadFileData)" class="preview-btn">预览</span>
                </el-col>
                <el-col :span="4" class="download-template">
                    <span @click="handleDownloadTemplate('driverDelegateTemplate.docx', '委派函模板', 'docx')" class="download-template-btn">下载模板</span>
                </el-col>
            </el-row>
            <el-row v-if="form.residentPerson === ZERO">
                <el-col :span="24" class="delegate-dateTime">
                    <el-form-item prop="delegateStartTime" class="delegate_start">
                        <el-date-picker
                            :disabled="approve"
                            :picker-options="pickerOptionsStart"
                            value-format="yyyy-MM-dd"
                            v-model="form.delegateStartTime"
                            type="date"
                            placeholder="请选择委派开始时间"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="delegateEndTime" class="delegate_end">
                        <el-date-picker
                            :disabled="approve"
                            :picker-options="pickerOptionsEnd"
                            value-format="yyyy-MM-dd"
                            v-model="form.delegateEndTime"
                            type="date"
                            placeholder="请选择委派结束时间"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="confirmDialog" v-if="!approve">确 定</el-button>
        </span>
        <!-- 附件预览弹窗 -->
        <preview
            :attachmentList="fileData.attachmentList"
            v-if="fileData.attachmentShow"
            :attachmentShow.sync="fileData.attachmentShow"
            :rowData="fileData.rowData"
        ></preview>
    </el-dialog>
</template>

<script>
import registerUpload from '../../../../../../components/upload/Index.vue';
import preview from '../../../../../../components/viewAttachment.vue';
import { dictWithUrl } from '@/components/lots/api.js';
import { getCountrys, getCitys, getProvinces } from '../../../../../../utils/getArea.js';
import { singlePersons, modifyPersons, addPersons, getContactApproveDetail, revokeApprove } from '../../../../../../api/register/person.js';
import { ZERO, ONE, TWO, THREE, PERSON, AUDIT_STATUS, LOGISTICS_SUPPLIER } from '../../../../../../constant/constant.js';
import { getExample, downloadAttachment } from '../../../../../../api/register/driver.js';
import { formData, formRules, props } from './AddOrEditContactDialog.js';

export default {
    name: 'add-or-edit-dialog',
    components: { registerUpload, preview },
    props: { ...props },
    data() {
        return {
            ZERO,
            ONE,
            TWO,
            title: '新增',
            loading: false,
            form: { ...formData }, // 表单数据
            rules: { ...formRules }, // 表单校验规则
            countryOptions: [], // 国家
            provinceOptions: [], // 省份
            cityOptions: [], // 城市
            firstFlag: 0,
            uploadFileData: {
                fileName: 'delegateFileName', // 委派函上传
                fileUrl: 'delegateFileUrl',
                fileId: 'delegateFileId',
                errMsg: '请上传委派函',
                example: 'delegate.jpg',
                examplePicWidth: '500px',
                examplePicHeight: '680px'
            },
            fileData: { // 委托函附件预览相关数据
                attachmentShow: false,
                attachmentList: [],
                rowData: {},
                imgSrcPathObj: {}
            },
            pickerOptionsStart: { disabledDate: time => { return time.getTime() < new Date(new Date().toLocaleDateString()).getTime(); } },
            pickerOptionsEnd: {
                disabledDate: time => {
                    return time.getTime() <= new Date(new Date().toLocaleDateString()).getTime() ||
                    time.getTime() >= new Date(new Date().toLocaleDateString()).getTime() + (365 * 3600 * 24 * 1000);
                }
            },
            approveInfo: {
                approvalUserName: '', // 审批人
                approvalStatus: '', // 审批进度
                approvalStatusText: '', // 审批进度文本
                commitTime: '', // 提交时间
                approvalOpinion: '', // 驳回理由
                approvalTime: '', // 提交时间
                commitUserCode: ''
            },
            dict: {},
            createUserFlagDisabled: false,
            AUDIT_STATUS
        };
    },
    methods: {
        /** 关闭弹窗 **/
        closeDialog() {
            this.firstFlag = 0;
            this.$refs.form.resetFields();
            this.$emit('closeDialog', false);
        },
        /** 管理端新增账号时，判断账号列表是否为空，若是 => 只能允许新增主账号才能提交 **/
        judgeManageFirstAccount() {
            if (this.manage && this.noAccount && this.form.userType === TWO) {
                return true;
            } else {
                return false;
            }
        },
        /** 新增编辑成功后操作 **/
        handleSaveSuccess() {
            this.firstFlag = 0;
            this.$message.success('保存成功！');
            this.$refs.form.resetFields();
            this.$emit('confirmDialog', false);
        },
        /** 新增 **/
        handleAddPerson() {
            this.loading = true
            this.form.supplierCode = this.supplierCode;
            addPersons(JSON.stringify(this.form)).then(res => {
                if (res && +res.code === 0) {
                    this.handleSaveSuccess();
                }
            }).finally(() => { this.loading = false });
        },
        /** 编辑 **/
        handleModifyPerson() {
            this.loading = true
            delete this.form.createUserFlag;
            modifyPersons(this.id, JSON.stringify(this.form)).then(res => {
                if (res && +res.code === 0) {
                    this.handleSaveSuccess();
                }
            }).finally(() => { this.loading = false });
        },
        /** 确定 **/
        confirmDialog() {
            this.handleVerify().then(() => {
                if (this.form.idCard) {
                    this.form.idCard = this.form.idCard.toUpperCase();
                }
                if (this.id) {
                    this.handleModifyPerson();
                } else {
                    if (this.judgeManageFirstAccount()) {
                        return this.$message.warning('当前供应商没有主账号，请先新增主账号！');
                    }
                    if (this.hasMainAccount && this.form.userType === ONE) {
                        return this.$message.warning('当前供应商已有主账号，不能重复添加！');
                    }
                    this.handleAddPerson();
                }
            }).catch(() => {});
        },
        /** 表单校验 **/
        handleVerify() {
            return new Promise((resolve) => {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        resolve();
                    }
                });
            });
        },
        /** 附件示例 **/
        showpopover(example) {
            getExample(example).then(res => {
                const blob = new Blob([res], { type: 'text/plain' });
                this.$set(this.fileData.imgSrcPathObj, example, URL.createObjectURL(blob));
            });
        },
        /** 附件上传成功回调 **/
        uploadSuccess(data) {
            const name = data.flag.split('#')[0];
            const url = data.flag.split('#')[1];
            const id = data.flag.split('#')[2];
            if (name === 'delegateFileName') { // 委派函不使用orc
                this.$set(this.form, name, data.data.data.localFileName);
                this.$set(this.form, url, data.data.data.downUrl);
                this.$set(this.form, id, data.data.data.id);
                this.rules.delegateStartTime[0].required = true;
                this.rules.delegateEndTime[0].required = true;
                this.form.delegateStartTime = '';
                this.form.delegateEndTime = '';
            }
            this.fileData.attachmentList = [this.form['delegateFileUrl']];
        },
        /** 附件预览 **/
        view(data) {
            if (this.form[data.fileUrl]) {
                const obj = {
                    downUrl: this.form[data.fileUrl],
                    fileName: this.form[data.fileName],
                    fileId: this.form[data.fileId]
                };
                this.fileData.rowData = obj;
                this.fileData.attachmentShow = true;
            } else {
                if (this.uploadFileData.fileUrl === data.fileUrl) {
                    this.$message.warning(this.uploadFileData.errMsg);
                }
            }
        },
        /** 附件下载 **/
        handleDownloadTemplate(fileName, localFileName, type) {
            downloadAttachment(JSON.stringify({ fileName: fileName })).then(res => {
                let fileType = '';
                if (type === 'docx') {
                    fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                }
                if (type === 'xlsx') {
                    fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                }
                if (type === 'pptx') {
                    fileType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
                }
                const blob = new Blob([res], {
                    type: fileType
                });
                const objectUrl = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = objectUrl;
                a.download = localFileName;
                a.click();
            });
        },
        handleJudge(id) {
            if (this.approve) {
                this.title = '审批详情';
                getContactApproveDetail({ supplierCode: this.supplierCode, contactsId: id }).then(res => {
                    if (res && +res.code === 0) {
                        this.approveInfo.approvalUserName = res.data.approvalUserName;
                        this.approveInfo.approvalStatus = res.data.approvalStatus;
                        this.approveInfo.approvalStatusText = this.dict['SRM_AUDIT_STATUS'][res.data.approvalStatus];
                        this.approveInfo.commitTime = res.data.commitTime;
                        this.approveInfo.approvalOpinion = res.data.approvalOpinion;
                        this.approveInfo.approvalTime = res.data.approvalTime;
                        this.approveInfo.commitUserCode = res.data.commitUserCode;
                        this.form = res.data;
                        this.form.userType = String(this.form.userType);
                        if (this.$refs['form']) {
                            this.$refs['form'].resetFields();
                        }
                    }
                });
                return;
            }
            if (id) {
                this.title = '编辑';
                singlePersons(id).then(res => {
                    if (res && +res.code === 0) {
                        res.data.residentPerson = res.data.residentPerson + '';
                        this.form = res.data;
                        this.form.userType = String(this.form.userType);
                        this.$refs['form'].resetFields();
                    }
                });
            } else {
                this.title = '新增';
                this.form = JSON.parse(JSON.stringify(formData));
                if(this.$store.state.supplier){
                    //供应商类型=物流供应商,主体性质=个体,新增
                    if(this.$store.state.supplier.supplierType === LOGISTICS_SUPPLIER && this.$store.state.supplier.propertyNature === PERSON){
                        this.form.createUserFlag = ''
                        this.createUserFlagDisabled = true
                    }else{
                        this.createUserFlagDisabled = false
                    }
                }else{
                    //供应商类型=物流供应商,主体性质=个体,新增
                    if(this.supplierTab.supplierType === LOGISTICS_SUPPLIER && this.supplierTab.propertyNature === PERSON){
                        this.form.createUserFlag = ''
                        this.createUserFlagDisabled = true
                    }else{
                        this.createUserFlagDisabled = false
                    }
                }
            }
            if (this.$refs['form']) {
                this.$refs['form'].resetFields();
            }
        },
        handleRevoke() {
            this.$confirm('是否确定撤回？', '撤回确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                revokeApprove({ supplierCode: this.supplierCode, contactsId: this.id }).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('撤回成功！');
                        this.closeDialog();
                    }
                });
            });
        }
    },
    computed: {
        country() {
            return this.form.countryCode;
        },
        province() {
            return this.form.provinceCode;
        },
        city() {
            return this.form.cityCode;
        }
    },
    mounted() {
        dictWithUrl('SRM_AUDIT_STATUS').then(res => {
            this.dict = res.data;
        });
    },
    watch: {
        openAddOrEditDialog(nVal) {
            if (nVal) {
                getCountrys().then(res => {
                    this.firstFlag += 1;
                    this.countryOptions = [].concat(res);
                });
            }
        },
        id: {
            handler(nVal) {
                this.handleJudge(nVal);
            },
            immediate: true
        },
        country(nVal) {
            if (nVal) {
                getProvinces(nVal).then(res => {
                    this.firstFlag += 1;
                    this.provinceOptions = [].concat(res);
                    if (this.firstFlag > THREE) {
                        this.$set(this.form, 'provinceCode', '');
                        this.$set(this.form, 'cityCode', '');
                    }
                });
            } else {
                this.$set(this.form, 'provinceCode', '');
                this.$set(this.form, 'cityCode', '');
            }
        },
        province(nVal) {
            if (nVal) {
                if (!this.form.countryCode) {
                    this.$message.warning('请选择国家');
                    this.$set(this.form, 'provinceCode', '');
                } else {
                    getCitys(nVal).then(res => {
                        this.firstFlag += 1;
                        this.cityOptions = [].concat(res);
                        if (this.firstFlag > THREE) {
                            this.$set(this.form, 'cityCode', '');
                        }
                    });
                }
            } else {
                this.$set(this.form, 'cityCode', '');
            }
        },
        city(nVal) {
            if (nVal) {
                if (!this.form.provinceCode || !this.form.countryCode) {
                    this.$message.warning('请选择国家和省份');
                    this.$set(this.form, 'cityCode', '');
                }
            }
        },
        propertyNature: {
            handler(nVal) {
                this.rules.contactsEmail[0].required = !(nVal === PERSON);
            },
            immediate: true
        },
        'form.residentPerson'(nVal) { // 是否驻场人员选择是时，身份证号由非必填调整为必填，并且显示委派函（必填）上传附件和填写时间信息，否则不显示委派函
            if (nVal) {
                this.rules.idCard[0].required = (nVal === ZERO);
                this.rules.delegateFileName[0].required = (nVal === ZERO);
                if (nVal === ONE) {
                    ['delegateFileId', 'delegateFileName', 'delegateFileUrl', 'delegateStartTime', 'delegateEndTime'].forEach(k => (this.form[k] = ''));
                    this.$refs.form.clearValidate('idCard');
                }
            }
        }
    }
};
</script>
<style lang="less">
@import url('./AddOrEditContactDialog.less');
</style>
